import { render, staticRenderFns } from "./CustomTime.vue?vue&type=template&id=04883864&scoped=true&"
import script from "./CustomTime.vue?vue&type=script&lang=js&"
export * from "./CustomTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04883864",
  null
  
)

export default component.exports